
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconInternet = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 19a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5zm-.002-9.5c-2.412.008-4.724.929-6.436 2.563a1.216 1.216 0 0 0 0 1.762 1.338 1.338 0 0 0 1.833 0 6.636 6.636 0 0 1 4.603-1.836c1.728 0 3.384.66 4.603 1.836.24.236.568.37.91.375.54.03 1.044-.265 1.264-.74.22-.476.11-1.032-.275-1.397-1.728-1.65-4.067-2.571-6.502-2.563z",
  fill: "#414045"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.999 4.5c-3.792.01-7.427 1.456-10.117 4.025-.51.49-.51 1.285 0 1.775s1.337.49 1.847 0c4.569-4.387 11.97-4.387 16.54 0 .245.234.578.364.923.362.346.002.678-.128.923-.362.247-.235.385-.554.385-.888 0-.333-.139-.652-.385-.887C19.425 5.955 15.791 4.51 12 4.5z",
  fill: "#414045"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M12 19a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5zM11.998 9.5c-2.412.008-4.724.929-6.436 2.563a1.216 1.216 0 0 0 0 1.762 1.338 1.338 0 0 0 1.833 0 6.636 6.636 0 0 1 4.603-1.836c1.728 0 3.384.66 4.603 1.836.24.236.568.37.91.375.54.03 1.044-.265 1.264-.74.22-.476.11-1.032-.275-1.397-1.728-1.65-4.067-2.571-6.502-2.563z\" fill=\"#414045\"/>\r\n    <path d=\"M11.999 4.5c-3.792.01-7.427 1.456-10.117 4.025-.51.49-.51 1.285 0 1.775s1.337.49 1.847 0c4.569-4.387 11.97-4.387 16.54 0 .245.234.578.364.923.362.346.002.678-.128.923-.362.247-.235.385-.554.385-.888 0-.333-.139-.652-.385-.887C19.425 5.955 15.791 4.51 12 4.5z\" fill=\"#414045\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/iconInternet.a7d38bd877ac6d9a92d2fa66079538b8.svg"),
        {
          React: SvgIconInternet,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      